import Component_WithHooks_247c18807aec1d16bcf3b1eb74536b59 from "../../../../content/guides/react-with-imperative-babylonjs/WithHooks";
import Devtool_WithHooks_247c18807aec1d16bcf3b1eb74536b59 from "!!@devtool/loader!../../../../content/guides/react-with-imperative-babylonjs/WithHooks";
import Component_FullImperative_247c18807aec1d16bcf3b1eb74536b59 from "../../../../content/guides/react-with-imperative-babylonjs/FullImperative";
import Devtool_FullImperative_247c18807aec1d16bcf3b1eb74536b59 from "!!@devtool/loader!../../../../content/guides/react-with-imperative-babylonjs/FullImperative";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_WithHooks_247c18807aec1d16bcf3b1eb74536b59,
  Devtool_WithHooks_247c18807aec1d16bcf3b1eb74536b59,
  Component_FullImperative_247c18807aec1d16bcf3b1eb74536b59,
  Devtool_FullImperative_247c18807aec1d16bcf3b1eb74536b59,
  DevTool,
  React
};